/**
 * Translation layer for the industry pages — the same pattern as
 * localizeService: English copy lives in data/industries.js, translations in
 * the locale files under flat keys, and anything missing falls back to
 * English.
 *
 *   "ind.healthcare.title":      "…"
 *   "ind.healthcare.sol.2.t":    "…"   // solution 3, title
 *   "ind.healthcare.faq.0.a":    "…"   // FAQ 1, answer
 *
 * slug, visual, projects, services, seoTitle and seoDescription stay as they
 * are: only the English pages are prerendered for search engines.
 */

const pick = (translations, key, fallback) => {
  const value = translations[key]
  return typeof value === 'string' && value.trim() ? value : fallback
}

export const industryKey = (slug, field) => `ind.${slug}.${field}`

const pairs = (items, prefix, t) =>
  items.map((item, i) => ({ title: t(`${prefix}.${i}.t`, item.title), text: t(`${prefix}.${i}.d`, item.text) }))

export const localizeIndustry = (industry, translations) => {
  if (!industry || !translations) return industry
  const t = (field, fallback) => pick(translations, industryKey(industry.slug, field), fallback)

  return {
    ...industry,
    name: t('name', industry.name),
    title: t('title', industry.title),
    summary: t('summary', industry.summary),
    tagline: t('tagline', industry.tagline),
    lead: t('lead', industry.lead),
    statement: t('statement', industry.statement),
    intro: industry.intro.map((paragraph, i) => t(`intro.${i}`, paragraph)),
    solutions: pairs(industry.solutions, 'sol', t),
    sectors: pairs(industry.sectors, 'sec', t),
    reasons: pairs(industry.reasons, 'why', t),
    outcomes: pairs(industry.outcomes, 'out', t),
    faq: industry.faq.map((item, i) => ({
      question: t(`faq.${i}.q`, item.question),
      answer: t(`faq.${i}.a`, item.answer),
    })),
  }
}

export const localizeIndustries = (industries, translations) =>
  industries.map((industry) => localizeIndustry(industry, translations))

export default localizeIndustry
